import { useState } from "react";
import { Link } from "react-router-dom";
import PreferenceCentre from "../consent/PreferenceCentre";
import ContactDetails from "../shared/ContactDetails";
import SocialLinks from "../shared/SocialLinks";
import "./Footer.css";
import Logo from "../shared/Logo";

// The official accounts come from SOCIAL_PROFILES in src/config/site.js,
// through SocialLinks — never listed here. Five networks used to be linked
// from this file pointing at bare domain roots (the network's home page, not
// an Emporia profile); the real profiles arrived 2026-10-11.

// Each entry is a real React Router path — see src/App.js.
// Contact, Size Guide and Blog were removed for good on 2026-09-29, by the
// owner's decision — the pages and routes too, not just these links.
// Footer.test.jsx fails if any of them comes back.
const helpLinks = [
  { label: "About", to: "/about" },
  { label: "Returns Policy", to: "/returns" },
  { label: "Shipping Info", to: "/shipping" },
];

// Contact details are real as of 2026-09-27, and they are LINKS rather than
// text: a phone number on a phone should be tappable, and an email address
// should open a mail client. ContactDetails still renders nothing if the
// config is cleared — the hide-rather-than-invent rule is kept, because the
// previous version shipped an invented toll-free number and an address on a
// domain we do not own, and both reached Google's results.

const Footer = () => {
  const [showPrefs, setShowPrefs] = useState(false);

  return (
    <>
    <footer className="footer">
      <div className="footer__inner">

        {/* Top area: the logo on a row of its own, centred over the contact
            group (not the page). It sits in the contact group's grid column
            but is NOT part of that group. Then one row of three groups:
            contact -> nav -> socials. */}
        <div className="footer__top">
          <div className="footer__logo-row">
            <Logo className="footer__logo" />
          </div>

          <p className="footer__contact footer__group">
            <ContactDetails variant="inline" showHours={false} />
          </p>

          {/* A real list of real links: one <li> per destination, so the
              structure is legible to a crawler rather than a row of
              anonymous anchors. */}
          <nav className="footer__nav footer__group" aria-label="Footer">
            <ul>
              {helpLinks.map((l) => (
                <li key={l.label}><Link to={l.to}>{l.label}</Link></li>
              ))}
            </ul>
          </nav>

          <SocialLinks className="footer__socials footer__group" />
        </div>

        <div className="footer__divider" />

        <div className="footer__bottom">
          <p className="footer__copy footer__group">© {new Date().getFullYear()} emporia.ke</p>
          <div className="footer__legal-links footer__group">
            <Link to="/terms">Terms</Link>
            <Link to="/privacy">Privacy</Link>
            <button type="button" onClick={() => setShowPrefs(true)}>Cookie Settings</button>
            <Link to="/sell">Sell on Emporia</Link>
            {/* The only public way into the seller portal (owner,
                2026-10-18): footer only, not the main menu. */}
            <Link to="/sell/portal/login">Seller sign in</Link>
          </div>
          <div className="footer__payments footer__group">
            {[
              { label: "M-Pesa", src: "/Mpesa.png" },
              { label: "Visa", src: "/visa.png" },
              { label: "Mastercard", src: "/Mastercard.svg" },
            ].map((p) => (
              <span key={p.label} className="footer__pay">
                <img src={p.src} alt={p.label} />
              </span>
            ))}
          </div>
        </div>

      </div>
    </footer>
    {showPrefs && <PreferenceCentre onClose={() => setShowPrefs(false)} />}
    </>
  );
};

export default Footer;
